import { rankingItems } from '@/mocks/home';

const trendIcon = (trend: string) => {
  if (trend === 'up') return <i className="ri-arrow-up-line text-primary-500 text-xs"></i>;
  return <i className="ri-arrow-down-line text-foreground-400 text-xs"></i>;
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-bar-chart-line text-sm"></i>
            实时热榜
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            热度飙升榜
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            基于全网讨论热度实时更新，最火爆的八卦话题都在这里
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer transition-colors hover:bg-background-100 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-primary-400 text-white' :
                item.rank === 3 ? 'bg-accent-400 text-white' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-foreground-950 text-sm font-medium truncate">{item.title}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${
                  item.tag === '爆' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                  'bg-secondary-100 text-secondary-700'
                }`}>{item.tag}</span>
                <div className="flex items-center gap-0.5">
                  {trendIcon(item.trend)}
                  <span className="text-foreground-500 text-xs">{item.heat}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}